/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import ThreadVotes from './ThreadVotes';
import UserInfo from './UserInfo';

function ThreadItem({
  id, title, body, category, createdAt, user, upVotesBy, downVotesBy, totalComments, authUser,
}) {
  const navigate = useNavigate();

  const onThreadClick = () => {
    navigate(`/thread/${id}`);
  };

  const onThreadPress = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      navigate(`/thread/${id}`);
    }
  };

  return (
    <div className="thread-item">
      <UserInfo createdAt={createdAt} avatar={user.avatar} name={user.name} category={category} />
      <article className="thread-item__article-homepage">
        <div style={{ cursor: 'pointer' }} role="button" tabIndex={0} onClick={onThreadClick} onKeyDown={onThreadPress}>
          <h2 className="thread-item__title">{title}</h2>
        </div>
        <p className="thread-item__text" dangerouslySetInnerHTML={{ __html: body }} />
      </article>
      <ThreadVotes
        id={id}
        upVotesBy={upVotesBy}
        downVotesBy={downVotesBy}
        totalComments={totalComments}
        authUser={authUser}
      />
    </div>
  );
}

const userShape = {
  id: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string,
  avatar: PropTypes.string,
};

const threadItemShape = {
  id: PropTypes.string,
  title: PropTypes.string,
  totalComments: PropTypes.number,
  body: PropTypes.string,
  category: PropTypes.string,
  createdAt: PropTypes.string,
  authUser: PropTypes.shape(userShape).isRequired,
  user: PropTypes.shape(userShape).isRequired,
};

ThreadItem.propTypes = {
  ...threadItemShape,
};

export { threadItemShape };

export default ThreadItem;
